import { EXPERIMENTAL_FEATURES } from "./registry";
import type { ExperimentalFeatureId } from "./registry";
import { readExperimentalFeatureEnv, resolveExperimentalFeature } from "./resolve-experimental-feature";

// Synchronous flag read for non-React code paths (`routes.ts`, directory row URL builders) that
// cannot subscribe to `useExperimentalFeature`. Call sites in React should prefer the hook when
// the value can be passed down (e.g. notification URL builders).
function readStoredChoice(storageKey: string): boolean | null {
  if (typeof localStorage === "undefined") {
    return null;
  }
  const stored = localStorage.getItem(storageKey);
  if (stored === null) {
    return null;
  }
  return stored === "true";
}

export function readExperimentalFeatureEnabled(id: ExperimentalFeatureId): boolean {
  const feature = EXPERIMENTAL_FEATURES[id];
  const env = readExperimentalFeatureEnv();
  const own = resolveExperimentalFeature(feature, env, readStoredChoice(feature.storageKey));
  if (!own.available || !own.enabled) {
    return false;
  }
  if (!feature.requires) {
    return true;
  }
  const required = EXPERIMENTAL_FEATURES[feature.requires];
  const requiredState = resolveExperimentalFeature(required, env, readStoredChoice(required.storageKey));
  return requiredState.available && requiredState.enabled;
}
